import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-media-card',
  components: {},
})
export default class MediaCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    if (action === 'edit') {
      action = this.$authorizationService.hasPermissions(['manage_media']) ? action : 'show';
    }
    this.$emit('action-clicked', action, row);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
